import React, { useContext, useEffect } from "react";
import { Route, Routes, Navigate, useLocation } from "react-router-dom";
import ArchivedUserList from "../container/Users/ArchivedUserList";
import CreateAdmin from "../container/Users/CreateAdmin";
import Error404 from "../container/errors/Error404";
import ExportCSVFile from "../container/Reports/ExportCSVFile";
import ForgotPassword from "../container/Authentication/ForgotPassword";
import Login from "../container/Authentication/Login";
import ManageReasons from "../container/Reports/ManageReasons";
import ReportList from "../container/Reports/ReportList";
import ResetPassword from "../container/Authentication/ResetPassword";
import UserList from "../container/Users/UserList";
import UserProfile from "../container/Users/UserProfile";
import { AppContext } from "../context/AppContext";
import AuthLayout from "../layout/authLayout";
import MainLayout from "../layout/mainLayout";
import ReportDetail from "../container/Reports/ReportDetail";
import MyAccount from "../container/MyAccount";
import EditMyAccount from "../container/EditMyAccount";
import PATH from "./RoutePath";
import Configurations from "../container/Settings/Configurations";
import ReEnableAccount from "../container/ReEnableAccount";
import UserReportList from "../container/Reports/UserReportList";
import UserReportDetail from "../container/Reports/UserReportDetail";

const MainRoutes: React.FC = () => {
  const { user } = useContext(AppContext);
  const location: any = useLocation();

  if (!user.isInitialized) {
    return null;
  }
  return (
    <Routes>
      {/* <Route
        index
        element={
          !user.isUserLoggedIn ? (
            <AuthLayout />
          ) : (
            <Navigate
              to={"/" + PATH.USERS.USERS_LIST}
              state={{ from: location }}
              replace
            />
          )
        }
      /> */}

      {/* Auth Routes */}
      <Route path="/auth" element={<AuthLayout />}>
        <Route path={PATH.AUTH.LOGIN} element={<Login />} />
        <Route path={PATH.AUTH.FORGOT_PASSWORD} element={<ForgotPassword />} />
        <Route path={PATH.AUTH.RESET_PASSWORD} element={<ResetPassword />} />
        <Route index element={<Navigate to={PATH.AUTH.LOGIN} />} />
      </Route>

      {/* Admin Routes */}
      <Route
        path={"/"}
        element={
          user?.isUserLoggedIn ? <MainLayout /> : <Navigate to="/auth/login" />
        }>
        {/* Manage Users */}
        <Route path={PATH.USERS.USERS_LIST} element={<UserList />} />
        <Route
          path={PATH.USERS.ARCHIVED_USERS_LIST}
          element={<ArchivedUserList />}
        />
        <Route path={PATH.USERS.CREATE_ADMIN} element={<CreateAdmin />} />
        <Route
          path={PATH.USERS.USER_PROFILE + ":userId"}
          element={<UserProfile />}
        />
        <Route path={PATH.ACCOUNT.MY_ACCOUNT} element={<MyAccount />} />
        <Route
          path={PATH.ACCOUNT.EDIT_MY_ACCOUNT}
          element={<EditMyAccount />}
        />

        {/* Manage Reports */}
        <Route path={PATH.REPORTS.REPORTS_LIST} element={<ReportList />} />
        <Route path={PATH.REPORTS.USER_REPORTS_LIST} element={<UserReportList />} />
        <Route
          path={PATH.REPORTS.EXPORT_CSV_FILE}
          element={<ExportCSVFile />}
        />
        <Route
          path={PATH.REPORTS.REPORT_DETAILS + ":reportId"}
          element={<ReportDetail />}
        />
          <Route
              path={PATH.REPORTS.USER_REPORT_DETAILS + ":reportId"}
              element={<UserReportDetail />}
          />
        <Route path={PATH.REPORTS.MANAGE_REASONS} element={<ManageReasons />} />
        <Route
          path={PATH.SETTINGS.CONFIGURATIONS}
          element={<Configurations />}
        />
        <Route index element={<Navigate to={PATH.USERS.USERS_LIST} />} />
      </Route>
      <Route
        path={PATH.RE_ENABLE_ACCOUNT.APPLICATION}
        element={<ReEnableAccount />}
      />
      <Route
        path={PATH.RE_ENABLE_ACCOUNT.NEW_APPLICATION}
        element={<ReEnableAccount />}
      />
      <Route path="*" element={<Error404 />} />
    </Routes>
  );
};

export default MainRoutes;
